module.exports = __webpack_public_path__ + "img/diagrama.7878f8f0.7878f8f0.png";